import { jsx as s, jsxs as e } from "@emotion/react/jsx-runtime";
import { BusinessCardContainer as i, BusinessCardGridItemContainer as r, BusinessImage as n, BusinessFullAddress as d, BusinessTitle as o, BusinessAddress as t } from "./BusinessCard.styled.js";
const a = () => /* @__PURE__ */ s(i, { children: /* @__PURE__ */ e(r, { children: [
  /* @__PURE__ */ s(n, {}),
  /* @__PURE__ */ e(d, { children: [
    /* @__PURE__ */ s(o, {}),
    /* @__PURE__ */ s(t, {})
  ] })
] }) });
export {
  a as BusinessCard
};
